module.exports = __webpack_public_path__ + "static/img/error-label-icon.1a1c25fa.svg";